import * as actions from './actionsTypes';

const initialData = {
  loader: false,
  saveLoader: false,
  Formations:[],
  FormationLength: 0,
}

export default function funcFormationsReducer(state = initialData, action){
  switch (action.type) {
    case actions.FUNC_FORMATION_LOADER:
      return {...state, loader: action.payload}
    case actions.FUNC_SAVE_FORMATION_LOADER:
      return {...state, saveLoader: action.payload}
    case actions.GET_FUNC_FORMATION:
      return {...state, Formations: action.payload.Formations, FormationLength: action.payload.FormationLength}
    default:
      return state
  }
}